import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import themeSite2 from '../theme-site2';

// Single-theme app since 18 Aug 2026: the /legacy mirror is retired, so the
// URL-based theme switch (and the robots-noindex juggling for /legacy) is
// gone. The old ../theme stays only as index.js's root baseline.
const Site2Provider = ({ children }) => (
  <ThemeProvider theme={themeSite2}>{children}</ThemeProvider>
);

export default Site2Provider;
